module.exports = __webpack_public_path__ + "media/src/images/card_design-8644d0b5c8ffc753638b205fc11d880f.svg";